@if (view$ | async; as view) {
    <div class="container-fluid my-3">
        <div class="text-end mb-3">
            <div class="d-inline-flex" [formGroup]="formGroup">
                @if (view.hasRemoteReadingDataService) {
                    <button
                        type="button"
                        class="btn btn-text-primary d-inline"
                        (click)="changeDateByDay(-1)">
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <div class="d-inline" style="max-width: 200px">
                        <app-input-date-group formControlName="selectedDate" />
                    </div>
                    <button
                        type="button"
                        class="d-inline btn btn-text-primary"
                        (click)="changeDateByDay(1)">
                        <i class="bi bi-chevron-right"></i>
                    </button>
                }
            </div>
            <button
                type="button"
                class="btn btn-outline-primary my-1"
                [disabled]="view.measuringPoints.loading"
                (click)="downloadFile(view)">
                {{ 'actions_export' | translate: 'online' : 'systems' }}
            </button>
            <button
                type="button"
                class="btn btn-outline-primary mx-2"
                (click)="onSort({column: 'proBraLoc', direction: 'asc'})">
                {{ 'utilities_STANDARDSORTORDER' | translate }}
            </button>

            <div ngbDropdown class="d-inline-block" container="body" placement="bottom-right">
                <button type="button" class="btn btn-primary" id="viewForm" ngbDropdownToggle>
                    {{ 'utilities_VIEW' | translate }}
                </button>
                <div ngbDropdownMenu aria-labelledby="viewForm">
                    <form class="px-4 py-3" novalidate [formGroup]="selectedColumnsForm">
                        <button
                            type="button"
                            class="btn btn-primary"
                            style="margin-bottom: 5px"
                            (click)="resetColumns()">
                            {{ 'utilities_standard-view' | translate }}
                        </button>
                        <app-checkbox-group
                            formControlName="proBraLoc"
                            [label]="
                                'properties_proBraLoc' | translate: 'online' : 'systems'
                            "></app-checkbox-group>
                        <app-checkbox-group
                            formControlName="consumerName"
                            [label]="'common_name' | translate"></app-checkbox-group>
                        <app-checkbox-group
                            formControlName="address"
                            [label]="
                                'properties_address' | translate: 'online' : 'systems'
                            "></app-checkbox-group>
                        <app-checkbox-group
                            formControlName="serialNo"
                            [label]="
                                'properties_meterNo' | translate: 'online' : 'systems'
                            "></app-checkbox-group>
                        <app-checkbox-group
                            formControlName="connectedTo"
                            [label]="'utilities_connected-to' | translate"></app-checkbox-group>
                        <app-checkbox-group
                            formControlName="roomId"
                            [label]="
                                'properties_placement' | translate: 'online' : 'systems'
                            "></app-checkbox-group>
                        <app-checkbox-group
                            formControlName="meterSuperTypeNo"
                            [label]="
                                'properties_type' | translate: 'online' : 'systems'
                            "></app-checkbox-group>
                        <app-checkbox-group
                            formControlName="alloUnitType"
                            [label]="
                                'properties_usage' | translate: 'online' : 'systems'
                            "></app-checkbox-group>
                        <app-checkbox-group
                            formControlName="mountingDate"
                            [label]="
                                'properties_mountingDate' | translate: 'online' : 'common'
                            "></app-checkbox-group>
                        <app-checkbox-group
                            formControlName="dismountedDate"
                            [label]="'utilities_dismount-date' | translate"></app-checkbox-group>
                        <app-checkbox-group
                            formControlName="unitFactor"
                            [label]="'utilities_Technical_factor' | translate"></app-checkbox-group>
                        <app-checkbox-group
                            formControlName="scale"
                            [label]="
                                'properties_scale' | translate: 'online' : 'systems'
                            "></app-checkbox-group>
                        @if (view.hasRemoteReadingDataService) {
                            <app-checkbox-group
                                formControlName="readingDate"
                                [label]="
                                    'properties_dateOfReading' | translate: 'online' : 'systems'
                                "></app-checkbox-group>
                            <app-checkbox-group
                                formControlName="meterValue"
                                [label]="
                                    'properties_meterValues' | translate: 'online' : 'systems'
                                "></app-checkbox-group>
                            <app-checkbox-group
                                formControlName="unit"
                                [label]="
                                    'properties_unit' | translate: 'online' : 'systems'
                                "></app-checkbox-group>
                        }
                    </form>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        @if (selectedColumnsForm.getRawValue().proBraLoc) {
                            <th
                                app-sortable-table-header
                                column="proBraLoc"
                                (sort)="onSort($event)"
                                [label]="
                                    'properties_proBraLoc' | translate: 'online' : 'systems'
                                "></th>
                        }
                        @if (selectedColumnsForm.getRawValue().consumerName) {
                            <th
                                app-sortable-table-header
                                column="consumerName"
                                (sort)="onSort($event)"
                                [label]="'common_name' | translate"></th>
                        }
                        @if (selectedColumnsForm.getRawValue().address) {
                            <th
                                app-sortable-table-header
                                column="address"
                                (sort)="onSort($event)"
                                [label]="
                                    'properties_address' | translate: 'online' : 'systems'
                                "></th>
                        }
                        @if (selectedColumnsForm.getRawValue().serialNo) {
                            <th
                                app-sortable-table-header
                                column="serialNo"
                                (sort)="onSort($event)"
                                [label]="
                                    'properties_meterNo' | translate: 'online' : 'systems'
                                "></th>
                        }
                        @if (selectedColumnsForm.getRawValue().connectedTo) {
                            <th
                                app-sortable-table-header
                                column="connectedTo"
                                (sort)="onSort($event)"
                                [label]="'utilities_connected-to' | translate"></th>
                        }
                        @if (selectedColumnsForm.getRawValue().roomId) {
                            <th
                                app-sortable-table-header
                                column="roomId"
                                (sort)="onSort($event)"
                                [label]="
                                    'properties_placement' | translate: 'online' : 'systems'
                                "></th>
                        }
                        @if (selectedColumnsForm.getRawValue().meterSuperTypeNo) {
                            <th
                                app-sortable-table-header
                                column="meterSuperTypeNo"
                                (sort)="onSort($event)"
                                [label]="'properties_type' | translate: 'online' : 'systems'"></th>
                        }
                        @if (selectedColumnsForm.getRawValue().alloUnitType) {
                            <th
                                app-sortable-table-header
                                column="alloUnitType"
                                (sort)="onSort($event)"
                                [label]="'properties_usage' | translate: 'online' : 'systems'"></th>
                        }
                        @if (selectedColumnsForm.getRawValue().mountingDate) {
                            <th
                                app-sortable-table-header
                                column="mountingDate"
                                (sort)="onSort($event)"
                                [label]="
                                    'properties_mountingDate' | translate: 'online' : 'common'
                                "></th>
                        }
                        @if (selectedColumnsForm.getRawValue().dismountedDate) {
                            <th
                                app-sortable-table-header
                                column="dismountedDate"
                                (sort)="onSort($event)"
                                [label]="'utilities_dismount-date' | translate"></th>
                        }
                        @if (selectedColumnsForm.getRawValue().unitFactor) {
                            <th
                                app-sortable-table-header
                                column="unitFactor"
                                (sort)="onSort($event)"
                                [label]="'utilities_Technical_factor' | translate"></th>
                        }
                        @if (selectedColumnsForm.getRawValue().scale) {
                            <th
                                app-sortable-table-header
                                column="scale"
                                (sort)="onSort($event)"
                                [label]="'properties_scale' | translate: 'online' : 'systems'"></th>
                        }
                        @if (view.hasRemoteReadingDataService) {
                            @if (selectedColumnsForm.getRawValue().readingDate) {
                                <th
                                    app-sortable-table-header
                                    column="readingDate"
                                    (sort)="onSort($event)"
                                    [label]="
                                        'properties_dateOfReading' | translate: 'online' : 'systems'
                                    "></th>
                            }
                            @if (selectedColumnsForm.getRawValue().meterValue) {
                                <th
                                    app-sortable-table-header
                                    column="meterValue"
                                    (sort)="onSort($event)"
                                    [label]="
                                        'properties_meterValues' | translate: 'online' : 'systems'
                                    "></th>
                            }
                            @if (selectedColumnsForm.getRawValue().unit) {
                                <th
                                    app-sortable-table-header
                                    column="unit"
                                    (sort)="onSort($event)"
                                    [label]="
                                        'properties_unit' | translate: 'online' : 'systems'
                                    "></th>
                            }
                        }
                    </tr>
                    <tr [formGroup]="formGroupFilter">
                        @if (selectedColumnsForm.getRawValue().proBraLoc) {
                            <th class="align-top">
                                <app-input-text-group
                                    [formControl]="
                                        formGroupFilter.controls.proBraLoc
                                    "></app-input-text-group>
                            </th>
                        }
                        @if (selectedColumnsForm.getRawValue().consumerName) {
                            <th class="align-top">
                                <app-input-text-group
                                    [formControl]="
                                        formGroupFilter.controls.name
                                    "></app-input-text-group>
                            </th>
                        }
                        @if (selectedColumnsForm.getRawValue().address) {
                            <th class="align-top">
                                <app-input-text-group
                                    [formControl]="
                                        formGroupFilter.controls.address
                                    "></app-input-text-group>
                            </th>
                        }
                        @if (selectedColumnsForm.getRawValue().serialNo) {
                            <th class="align-top">
                                <app-input-text-group
                                    [formControl]="
                                        formGroupFilter.controls.serialNo
                                    "></app-input-text-group>
                            </th>
                        }
                        @if (selectedColumnsForm.getRawValue().connectedTo) {
                            <th class="align-top">
                                <app-input-text-group
                                    [formControl]="
                                        formGroupFilter.controls.connectedTo
                                    "></app-input-text-group>
                            </th>
                        }
                        @if (selectedColumnsForm.getRawValue().roomId) {
                            <th class="align-top">
                                <app-input-text-group
                                    [formControl]="
                                        formGroupFilter.controls.roomId
                                    "></app-input-text-group>
                            </th>
                        }

                        @if (selectedColumnsForm.getRawValue().meterSuperTypeNo) {
                            <th class="align-top">
                                <app-input-dropdown-checkboxes
                                    [formControl]="formGroupFilter.controls.meterSuperTypeNo" />
                            </th>
                        }
                        @if (selectedColumnsForm.getRawValue().alloUnitType) {
                            <th class="align-top">
                                <app-input-dropdown-checkboxes
                                    [formControl]="formGroupFilter.controls.alloUnitType" />
                            </th>
                        }
                        @if (selectedColumnsForm.getRawValue().mountingDate) {
                            <th class="align-top">
                                <app-input-date-group
                                    [formControl]="
                                        formGroupFilter.controls.mountingDate
                                    "></app-input-date-group>
                            </th>
                        }
                        @if (selectedColumnsForm.getRawValue().dismountedDate) {
                            <th class="align-top">
                                <app-input-date-group
                                    [formControl]="
                                        formGroupFilter.controls.dismountedDate
                                    "></app-input-date-group>
                            </th>
                        }
                        @if (selectedColumnsForm.getRawValue().unitFactor) {
                            <th class="align-top">
                                <app-input-text-group
                                    [formControl]="
                                        formGroupFilter.controls.unitFactor
                                    "></app-input-text-group>
                            </th>
                        }
                        @if (selectedColumnsForm.getRawValue().scale) {
                            <th class="align-top">
                                <app-input-text-group
                                    [formControl]="
                                        formGroupFilter.controls.scale
                                    "></app-input-text-group>
                            </th>
                        }
                        @if (view.hasRemoteReadingDataService) {
                            @if (selectedColumnsForm.getRawValue().readingDate) {
                                <th class="align-top">
                                    <app-input-date-group
                                        [formControl]="
                                            formGroupFilter.controls.readingDate
                                        "></app-input-date-group>
                                    @if (view.isNoReadingFilterEnabled) {
                                        <app-checkbox-group
                                            class="d-block mt-2 fw-normal text-nowrap"
                                            [formControl]="
                                                formGroupFilter.controls.neverReceivedReading
                                            "
                                            [label]="
                                                'utilities_never-received-reading' | translate
                                            " />
                                        <app-input-number-group
                                            class="d-block mt-1 fw-normal no-reading-days"
                                            [formControl]="
                                                formGroupFilter.controls.noReadingForDays
                                            "
                                            [descriptor]="
                                                'utilities_days-without-reading' | translate
                                            " />
                                    }
                                </th>
                            }
                            @if (selectedColumnsForm.getRawValue().meterValue) {
                                <th class="align-top">
                                    <app-input-text-group
                                        [formControl]="
                                            formGroupFilter.controls.meterValue
                                        "></app-input-text-group>
                                </th>
                            }
                            @if (selectedColumnsForm.getRawValue().unit) {
                                <th class="align-top">
                                    <app-input-dropdown-checkboxes
                                        [formControl]="formGroupFilter.controls.unit" />
                                </th>
                            }
                        }
                    </tr>
                </thead>
                <tbody class="text-nowrap position-relative">
                    @if (view.measuringPoints.loading) {
                        <div
                            class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75">
                            <div style="background-color: transparent">
                                <app-load />
                            </div>
                        </div>
                    }

                    @for (
                        measuringPoint of view.measuringPoints.value
                            | slice: (page.value - 1) * view.pageSize : page.value * view.pageSize;
                        track $index
                    ) {
                        <tr>
                            @if (selectedColumnsForm.getRawValue().proBraLoc) {
                                <td>
                                    {{ measuringPoint.proBraLoc }}
                                </td>
                            }
                            @if (selectedColumnsForm.getRawValue().consumerName) {
                                <td>{{ measuringPoint.consumerName }}</td>
                            }
                            @if (selectedColumnsForm.getRawValue().address) {
                                <td>{{ measuringPoint.address }}</td>
                            }
                            @if (selectedColumnsForm.getRawValue().serialNo) {
                                <td>{{ measuringPoint.serialNo }}</td>
                            }
                            @if (selectedColumnsForm.getRawValue().connectedTo) {
                                <td>
                                    {{ measuringPoint.connectedTo }}
                                </td>
                            }
                            @if (selectedColumnsForm.getRawValue().roomId) {
                                <td>{{ measuringPoint.roomId }}</td>
                            }
                            @if (selectedColumnsForm.getRawValue().meterSuperTypeNo) {
                                <td>
                                    {{
                                        'mappers_meterType.' + measuringPoint.meterSuperTypeNo
                                            | translate: 'online' : 'common'
                                    }}
                                </td>
                            }
                            @if (selectedColumnsForm.getRawValue().alloUnitType) {
                                <td>
                                    {{
                                        'mappers_allocationUnitMap.' + measuringPoint.alloUnitType
                                            | translate: 'online' : 'common'
                                    }}
                                </td>
                            }
                            @if (selectedColumnsForm.getRawValue().mountingDate) {
                                <td>{{ measuringPoint.mountingDate | appdate }}</td>
                            }
                            @if (selectedColumnsForm.getRawValue().dismountedDate) {
                                <td>{{ measuringPoint.dismountedDate | appdate }}</td>
                            }
                            @if (selectedColumnsForm.getRawValue().unitFactor) {
                                <td>{{ measuringPoint.unitFactor ?? null | appnumber }}</td>
                            }
                            @if (selectedColumnsForm.getRawValue().scale) {
                                <td>{{ measuringPoint.scale ?? null | appnumber }}</td>
                            }
                            @if (view.hasRemoteReadingDataService) {
                                @if (selectedColumnsForm.getRawValue().readingDate) {
                                    <td
                                        [ngClass]="{
                                            red:
                                                (view.selectedDate.toISODate() ?? '') >
                                                (measuringPoint.readingDate?.toISODate() ?? ''),
                                        }">
                                        {{ measuringPoint.readingDate | appdate }}
                                    </td>
                                }
                                @if (selectedColumnsForm.getRawValue().meterValue) {
                                    <td
                                        [ngClass]="{
                                            red:
                                                (view.selectedDate.toISODate() ?? '') >
                                                (measuringPoint.readingDate?.toISODate() ?? ''),
                                        }">
                                        {{
                                            measuringPoint.meterValue != null
                                                ? (measuringPoint.meterValue | appnumber)
                                                : '-'
                                        }}
                                    </td>
                                }
                                @if (selectedColumnsForm.getRawValue().unit) {
                                    <td>
                                        {{
                                            'mappers_measurementUnit.' + measuringPoint.unit
                                                | translate: 'online' : 'common'
                                        }}
                                    </td>
                                }
                            }
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="20" class="text-center">
                                {{ 'table_noResults' | translate: 'online' : 'common' }}
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    <div class="text-center">
        <app-pagination
            [collectionSize]="view.measuringPoints.value.length"
            [page]="page.value"
            (pageChange)="setPage($event)"
            (pageSizeChange)="setPageSize($event)"
            [pageSize]="view.pageSize">
            ></app-pagination
        >
    </div>
} @else {
    <app-load />
}
